<template>
    <div v-if="! isFetching">
        <div
            v-if="! dataLength"
            class="box-body with-border clearfix"
        >
            <p>There are no Short Domain Accounts in the system.</p>
        </div>
        <div v-else>
            <div
                v-if="havePagination(shortDomainAccounts.total, shortDomainAccounts.per_page)"
                class="box-body with-border clearfix"
                @click="preventEnter"
                @keydown="preventEnter"
            >
                <pagination
                    :class="isDisabled()"
                    :data="shortDomainAccounts"
                    :limit="$root.paginator.settings.limit"
                    :size="$root.paginator.settings.size"
                    class="pull-right no-margin vue-pagination"
                    show-disabled
                    @pagination-change-page="getData"
                >
                <span slot="prev-nav">
                    <i class="fa fa-angle-double-left"></i>
                </span>
                    <span slot="next-nav">
                    <i class="fa fa-angle-double-right"></i>
                </span>
                </pagination>
            </div>
            <div class="box-body table-responsive no-padding">
                <table class="table table-hover">
                    <thead>
                    <tr>
                        <th>ID</th>
                        <th>Name</th>
                        <th>Category</th>
                        <th>Provider</th>
                        <th class="text-center">Domains</th>
                        <th class="text-center">Parse Page</th>
                        <th class="text-center">Active</th>
                        <th class="text-right">Created At</th>
                        <th class="text-right">Updated At</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr
                        v-for="shortDomainAccount in shortDomainAccounts.data"
                        :key="shortDomainAccount.id"
                    >
                        <td>{{ shortDomainAccount.id }}</td>
                        <td>
                            <a
                                :href="getRoute(shortDomainAccount.id, 'show')"
                                :title="shortDomainAccount.name"
                            >
                                {{ shortDomainAccount.name }}
                            </a>
                        </td>
                        <td>{{ shortDomainAccount.category.name }}</td>
                        <td>{{ shortDomainAccount.provider.name }}</td>
                        <td class="text-center">
                            <BadgeTotal
                                :value="shortDomainAccount.domains_count"
                                color="gray"
                            />
                        </td>
                        <td class="text-center">
                            <BadgeTotal
                                :value="shortDomainAccount.parse_page"
                                color="gray"
                                title="Parse page"
                            />
                        </td>
                        <td class="text-center">
                            <ValueYesNo :value="shortDomainAccount.active"/>
                        </td>
                        <td class="text-right">{{ shortDomainAccount.created_at }}</td>
                        <td class="text-right">{{ shortDomainAccount.updated_at }}</td>
                        <td class="text-right">
                            <span v-if="! userOrPublisher">
                                <ModalContent
                                    v-if="shortDomainAccount.active"
                                    :id="shortDomainAccount.id"
                                    :route="route"
                                    type="deactivate"
                                    @click="isShowModal = true"
                                    @modalEmitData="emittedModalData"
                                />
                                <ModalContent
                                    v-else
                                    :id="shortDomainAccount.id"
                                    :route="route"
                                    type="activate"
                                    @click="isShowModal = true"
                                    @modalEmitData="emittedModalData"
                                />
                            </span>
                            <a
                                :href="getRoute(shortDomainAccount.id,'edit')"
                                class="btn btn-sm btn-primary"
                            >
                                <i class="fa fa-edit"></i>
                                <span class="sr-only">Edit</span>
                            </a>
                            <a
                                :href="getRoute(shortDomainAccount.id,'show')"
                                class="btn btn-sm btn-info"
                            >
                                <i class="fa fa-eye"></i>
                                <span class="sr-only">Show</span>
                            </a>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div
                v-if="shortDomainAccounts.total"
                class="box-footer clearfix"
                @click="preventEnter"
                @keydown="preventEnter"
            >
                <pagination
                    :class="isDisabled()"
                    :data="shortDomainAccounts"
                    :limit="$root.paginator.settings.limit"
                    :size="$root.paginator.settings.size"
                    class="pull-right no-margin vue-pagination"
                    show-disabled
                    @pagination-change-page="getData"
                >
                    <span slot="prev-nav">
                        <i class="fa fa-angle-double-left"></i>
                    </span>
                    <span slot="next-nav">
                        <i class="fa fa-angle-double-right"></i>
                    </span>
                </pagination>
            </div>
            <main-modal-form
                v-if="isShowModal"
                :modal="emittedModalValues"
                @close="isShowModal = false"
                @updateData="modalData($event)"
            />
        </div>
    </div>
    <!-- /.box-body -->
</template>

<script>
import BadgeTotal from '../../subcomponents/BadgeTotal';
import ValueYesNo from "../../subcomponents/ValueYesNo";
import ModalContent from "../../subcomponents/modals-content/ShortDomainAccountsContent";

export default {
    data() {
        return {
            shortDomainAccounts: {},
            emittedModalValues: {},
            isFetching: true,
            pageNumber: this.$route.query.page,
            disablePagination: true,
            userOrPublisher: true,
            isShowModal: false,
        }
    },
    props: {
        'route': Object,
        'type': Object,
    },
    mounted() {
        this.getData(this.pageNumber);
    },
    computed: {
        dataLength: function () {
            return this.shortDomainAccounts.data.length;
        },
    },
    methods: {
        emittedModalData(value) {
            this.emittedModalValues = value
        },
        modalData: function (e) {
            this.isShowModal = false
            _.merge(_.keyBy(this.shortDomainAccounts.data, 'id'), _.keyBy({0: e}, 'id'));
        },
        preventEnter: function (event) {
            if (this.disablePagination) {
                return event.preventDefault();
            }
        },
        getData(page = 1) {
            this.disablePagination = true;
            axios.get(this.$route.path + '/data?page=' + page)
                .then(response => {
                    if (String(page) !== String(this.$route.query.page)) {
                        this.$router.push({ query: Object.assign({}, this.$route.query, { page: String(page) }) });
                    }

                    if (page > response.data.shortDomainAccounts.last_page) {
                        return this.getData();
                    }

                    this.shortDomainAccounts = response.data.shortDomainAccounts;
                    this.userOrPublisher = response.data.userOrPublisher;
                    this.isFetching = false;
                    this.disablePagination = false
                });
        },
        getRoute: function (id, type) {
            return this.route[type].replace(':id:', id);
        },
        isDisabled: function () {
            return this.disablePagination ? 'disabled-box' : '';
        },
        havePagination: function (total, perPage) {
            return total > perPage;
        },
    },
    components: {
        BadgeTotal,
        ValueYesNo,
        ModalContent
    },
}
</script>
